import { z } from 'zod';
import type { BoothStatusData } from './booth-status';
import type { BoothOtpMode } from './generated';

export interface UpsertBoothRequest {
  id?: string | null;
  machineUid?: string | null;
  label?: string;
  terminalId?: string | null;
  jobsources?: string[] | null;
  /** UI locale applied at boot (null = global DEFAULT_LANGUAGE) */
  defaultLocaleId?: string | null;
  /** Fallback locale for job offers (null = none) */
  defaultTranslationLocaleId?: string | null;
  /** Skip the /language page and start in the default locale */
  interfacePreselected?: boolean;
  /** OTP channel used for candidate sign-in (absent = keep current value, null = reset to SMS) */
  otpMode?: BoothOtpMode | null;
  data?: BoothStatusData;
}

export const boothsQueryDtoSchema = z.object({
  page: z.coerce.number().int().positive().default(1).optional(),
  limit: z.coerce.number().int().positive().max(100).default(10).optional(),
});

export type BoothsQueryDto = z.infer<typeof boothsQueryDtoSchema>;
